export { default as FOOTER_QUERY } from './footer-component.graphql';
export { default as HEADER_QUERY } from './header-component.graphql';
export { default as COOKIES_QUERY } from './cookies-component.graphql';
export { default as TOP_ARTICLES_QUERY } from './top-articles-component.graphql';
export { default as ARTICLES_QUERY } from './articles-page.graphql';
export { default as ARTICLES_BY_TAG_QUERY } from './articles-by-tag-page.graphql';
export { default as ALL_ARTICLES_QUERY } from './all-articles.graphql';
export { default as INSIGHTS_QUERY } from './insights-page.graphql';
export { default as CAREER_QUERY } from './career-page.graphql';
export { default as CAREER_BY_NAME_QUERY } from './career-by-name-page.graphql';
export { default as CAREERS_QUERY } from './careers-page.graphql';
export { default as RECRUITMENT_QUERY } from './recruitment-page.graphql';
export { default as NOT_FOUND_QUERY } from './not-found-page.graphql';
export { default as SERVICES_QUERY } from './services-page.graphql';
export { default as CASE_STUDY_QUERY } from './case-study-page.graphql';
export { default as CLIENTS_QUERY } from './clients-page.graphql';
export { default as HOME_QUERY } from './home-page.graphql';
export { default as INSIGHT_NEXT_QUERY } from './insight-next-page.graphql';
export { default as INSIGHT_QUERY } from './insight-page.graphql';
export { default as INTERNAL_ERROR_QUERY } from './internal-server-error-page.graphql';
export { default as SUMMARIZED_ARTICLE_QUERY } from './summarized-article-openings.graphql';
export { default as PRIVACY_POLICY_QUERY } from './privacy-policy-page.graphql';
export { default as SUMMARIZED_JOB_QUERY } from './summarized-job-openings.graphql';
export { default as SEO_QUERY } from './seo.graphql';
export { default as NEWSLETTER_QUERY } from './newsletter.graphql';
export { default as PRODUCT_DESIGN_QUERY } from './product-design.graphql';
export { default as DEVELOPMENT_QUERY } from './development.graphql';
export { default as DISCOVERY_QUERY } from './discovery.graphql';
export { default as ESTIMATE_PROJECT_QUERY } from './estimate-project-page.graphql';
